import { Logo } from 'containers/Logo/Logo';
import { useFlysiteUrls } from 'hooks/useFlysiteUrls';
import { useSelector } from 'react-redux';
import { getCurrentLocale } from 'selectors/ui/ui';

import './Powered.scss';

const Powered = () => {
  const locale = useSelector(getCurrentLocale);
  const { flysiteUrl } = useFlysiteUrls(locale);

  return (
    <div className="Powered">
      <p className="Powered-text">Powered by</p>
      <a href={flysiteUrl} rel="noopener noreferrer" target="_blank">
        <Logo className="Powered-logo" size="small" />
      </a>
    </div>
  );
};

export { Powered };
